"use client";

import Reveal from "@/component/home/Reveal";
import { PROCESS } from "@/data/investment-data";
import { useContent } from "@/hooks/useContent";
import type { InvestContent } from "./asset";
import type { Locale } from "@/types/home";
import { useLocale } from "next-intl";

/** The investment process steps (panel-managed). */
export default function InvestProcess() {
  const locale = useLocale() as Locale;
  const ar = locale === "ar";
  const { data } = useContent<InvestContent>("investment");
  const steps = data?.process?.length ? data.process : PROCESS;
  return (
    <section className="bg-black/[0.03] py-16 md:py-24 dark:bg-white/[0.02]">
      <div className="mx-auto max-w-360 px-6 lg:px-10">
        <span className="text-[11px] uppercase tracking-widest text-accent">{ar ? "كيف تستثمر" : "How to invest"}</span>
        <div className="mt-10 grid gap-10 md:grid-cols-4">
          {steps.map((s, i) => (
            <Reveal key={i} i={i}>
              <div className="font-bebas text-6xl text-accent/25">{s.num}</div>
              <h3 className="mt-2 text-lg font-semibold text-ash dark:text-white">{s.title[locale]}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ash/60 dark:text-white/60">{s.body[locale]}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
